import kebabCase from "lodash/kebabCase";

import { isCoach } from "@/components/helpers/workspace/permissions";
import { getUser } from "@/components/session/JwtTokenManager";
import { Company } from "@/types/companies";

interface BuildCompanyUrlPathProps {
  company: Company;
  customerId?: string;
  embed?: boolean;
}

export function buildCompanyUrlPath({
  company,
  customerId,
  embed = false,
}: BuildCompanyUrlPathProps) {
  if (!company) {
    return "";
  }
  const user = getUser();
  const isCoachAsUserMode =
    customerId && user && isCoach() && user.id !== customerId;

  const { companySeoSlug, id, name } = company;

  const companySlug = companySeoSlug
    ? `${companySeoSlug}-${id}`
    : kebabCase(`${name}-${id}`);

  let url = embed ? `/embed/company/${companySlug}` : `/company/${companySlug}`;

  if (customerId && isCoachAsUserMode) {
    url = `/client/${customerId}${url}`;
  }

  return url;
}
